/**
 * Returns the same artist display name and profile pic shown on UserHome:
 * professional_name / profile_pic from artist details, else user name from auth, else "Artist Name".
 */

import { useEffect } from "react";
import { useArtistDetailsStore } from "@/stores/artistDetailsStore";
import { useAuthStore } from "@/stores/authStore";

const FALLBACK_NAME = "Artist Name";

export function useArtistDisplayName(): string {
  const { data: artistDetails, ensureFetched } = useArtistDetailsStore();
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    ensureFetched();
  }, [ensureFetched]);

  const userInfo = artistDetails?.user_info;
  return userInfo?.professional_name || user?.name || FALLBACK_NAME;
}

/** Profile pic URL from artist details (same as UserHome). */
export function useArtistProfilePic(): string | null {
  const { data: artistDetails, ensureFetched } = useArtistDetailsStore();

  useEffect(() => {
    ensureFetched();
  }, [ensureFetched]);

  const url = artistDetails?.user_info?.profile_pic;
  return typeof url === "string" && url.trim().length > 0 ? url.trim() : null;
}
